<template>
	<div class="row-no-full" v-loading="loading">
		<div class="search_input">
			<el-input style='width: 350px;' clearable type="text" placeholder="请输入乐天订单号" v-model="order_number">
			</el-input>
		</div>
		<div style="margin-left: 10px;">
			<el-button @click="submit()" type="info">导入erp</el-button>
		</div>
	</div>
</template>

<script>
	export default{
		name:'RakutenOrderApi',
		data(){
			return{
				order_number: '',
				loading:false,
			
			}
		},
		methods: {
			submit() {
				// console.log(this.order_number);
				if(this.order_number==''){
					this.alertError('填写订单号');
					return false;
				}else{
					this.loading = true;

					this.httpPost({
						url: '/admin/rakuten/rakutenOrderApiUpdate',
						data: {
							order_number:this.order_number,
							routePath: this.$route.path
						},
					}).then((re) => {
								
						// console.log(re);
						this.loading = false;
						this.alertSuccess(re.msg);
						// this.resetObj(this.order_number)
					})
				}
			},
		},
		created(){
			
		}
	}
</script>

<style>
</style>
